export default __webpack_public_path__ + "static/nodejs-3f4575471503de257a80b00edd002a74.png";